/* eslint-disable no-irregular-whitespace */
<template>
  <div class="mb-8 mt-px p-menu sm:mb-0" v-if="hasServices">

<!-- 風呂 -->
<div class="service-section box" v-if="bathtubType || bathtubQuality || bathtubType">
    <DashTitle text="風呂" />
    <div class="ten-item" v-if="bathtubType && bathtubType.equipServDetail2">
        <div v-for="(el1, index1) in bathtubType.equipServDetail2" :key="`bath-type-${index1}`">
          <div class="flex border justify-between" v-if="el1 && el1.equipServCd2 === 'A10010101'">
            <div class="title-bath">温泉</div>
            <div class="content-bath" v-if="isShow(el1.equipServValue2)">
              ○
            </div>
            <div class="content-bath" v-else>×</div>
          </div>
          <div class="flex border justify-between" v-if="el1 && el1.equipServCd2 === 'A10010102'">
            <div class="title-bath">大浴場</div>
            <div class="content-bath" v-if="isShow(el1.equipServValue2)">
              ○
            </div>
            <div class="content-bath" v-else>×</div>
          </div>
          <div class="flex border justify-between" v-if="el1 && el1.equipServCd2 === 'A10010103'">
            <div class="title-bath">露天風呂</div>
            <div class="content-bath" v-if="isShow(el1.equipServValue2)">
              ○
            </div>
            <div class="content-bath" v-else>×</div>
          </div>
          <div class="flex border justify-between" v-if="el1 && el1.equipServCd2 === 'A10010104'">
            <div class="title-bath">サウナ</div>
            <div class="content-bath" v-if="isShow(el1.equipServValue2)">
              ○
            </div>
            <div class="content-bath" v-else>×</div>
          </div>
          <div class="flex border justify-between" v-if="el1 && el1.equipServCd2 === 'A10010105'">
            <div class="title-bath">家族風呂</div>
            <div class="content-bath" v-if="isShow(el1.equipServValue2)">
              ○
            </div>
            <div class="content-bath" v-else>×</div>
          </div>
          <div class="flex border justify-between" v-if="el1 && el1.equipServCd2 === 'A10010106'">
            <div class="title-bath">天然温泉</div>
            <div class="content-bath" v-if="isShow(el1.equipServValue2)">
              ○
            </div>
            <div class="content-bath" v-else>×</div>
          </div>
          <div class="flex border justify-between" v-if="el1 && el1.equipServCd2 === 'A10010107'">
            <div class="title-bath">人工温泉</div>
            <div class="content-bath" v-if="isShow(el1.equipServValue2)">
              ○
            </div>
            <div class="content-bath" v-else>×</div>
          </div>
          <div class="flex border justify-between" v-if="el1 && el1.equipServCd2 === 'A10010108'">
            <div class="title-bath">ジャグジー</div>
            <div class="content-bath" v-if="isShow(el1.equipServValue2)">
              ○
            </div>
            <div class="content-bath" v-else>×</div>
          </div>
          <div class="flex border justify-between" v-if="el1 && el1.equipServCd2 === 'A10010109'">
            <div class="title-bath">水風呂</div>
            <div class="content-bath" v-if="isShow(el1.equipServValue2)">
              ○
            </div>
            <div class="content-bath" v-else>×</div>
          </div>
          <div class="flex border justify-between" v-if="el1 && el1.equipServCd2 === 'A10010110'">
            <div class="title-bath">岩盤浴</div>
            <div class="content-bath" v-if="isShow(el1.equipServValue2)">
              ○
            </div>
            <div class="content-bath" v-else>×</div>
          </div>
        </div>
    </div>

    <template v-if="bathtubQuality && bathtubQuality.equipServDetail2">
      <div class="flex pt-3 flex-wrap">
        <span class="pr-3">[泉質]</span>
        <span
          v-for="(el3, index3) in bathtubQuality.equipServDetail2"
          :key="`bath-type-${index3}`"
        >
          <span
            class="pr-3"
            v-if="
              el3 &&
              el3.equipServNm2 &&
              isShow(el3.equipServValue2)
            "
            
          >
            {{ el3.equipServNm2 }}
          </span>
        </span>
      </div>
    </template>

    <template v-if="bathtubEfficiency && bathtubEfficiency.equipServDetail2">
      <div class="flex pt-3 flex-wrap">
        <span class="pr-3">[効能]</span>
        <span v-for="(el4, index4) in bathtubEfficiency.equipServDetail2" :key="`bath-type-${index4}`">
          <span class="pr-3" v-if="
                      el4 &&
                      el4.equipServNm2 &&
                      isShow(el4.equipServValue2)
                    ">
            {{ el4.equipServNm2 }}
          </span>
        </span>
      </div>
    </template>
    <hr class="pt-8 sm:pt-3 std-line-breaker" />
</div>

<div class="service-section box" v-if="breakfastAndDinnerItems.length > 0">
  <DashTitle text="食事場所" />
  <TextHeightCutter :height="isMobile() ? 100 : 112.5" wrapper-class="content"
    :disableMoreButton="breakfastAndDinnerItems.length > 10">
    <ul class="plain-list-style two-column-list">
      <li v-for="(item, index) in breakfastItems" :key="`breakfast-type-${index}`">
        [朝食] &nbsp; {{ item.equipServNm2 }}
      </li>
      <li v-for="(item, index) in dinnerItems" :key="`dinner-type-${index}`">
        [夕食] &nbsp; {{ item.equipServNm2 }}
      </li>
    </ul>
  </TextHeightCutter>
  <hr class="std-line-breaker" />
</div>

<!-- 部屋設備・備品 -->
<div class="service-section box" v-if="roomFacilityEquipments.length > 0">
  <DashTitle text="部屋設備・備品" />
  <TextHeightCutter :height="isMobile() ? 100 : 112.5" wrapper-class="content"
    :disableMoreButton="roomFacilityEquipments.length > 10">
    <ul class="plain-list-style two-column-list">
      <li v-for="(el7, index7) in roomFacilityEquipments" :key="`bath-type-${index7}`">
        {{ el7.equipServNm2 }}
      </li>
    </ul>
  </TextHeightCutter>
  <hr class="std-line-breaker" />
</div>


<!-- 館内設備 -->
<div class="service-section box" v-if="buildingFacilities.length > 0">
  <DashTitle text="館内設備" />
  <TextHeightCutter :height="isMobile() ? 100 : 112.5" wrapper-class="content"
    :disableMoreButton="buildingFacilities.length > 10">
    <ul class="plain-list-style two-column-list">
      <li v-for="(el7, index7) in buildingFacilities" :key="`bath-type-${index7}`">
        {{ el7.equipServNm2 }}
      </li>
    </ul>
  </TextHeightCutter>
  <hr class="std-line-breaker" />
</div>


<!-- バリアフリー -->
<div class="service-section box" v-if="impedimentRemoval.length > 0">
  <DashTitle text="バリアフリー" />
  <TextHeightCutter :height="isMobile() ? 100 : 112.5" wrapper-class="content"
    :disableMoreButton="impedimentRemoval.length > 10">
    <ul class="plain-list-style two-column-list">
      <li v-for="(el9, index9) in impedimentRemoval" :key="`bath-type-${index9}`">
        {{ el9.equipServNm2 }}
      </li>
    </ul>
  </TextHeightCutter>
  <hr class="std-line-breaker" />
</div>



<!-- 利用可能クレジットカード -->
<div class="service-section box" v-if="creditCards">
  <DashTitle text="利用可能クレジットカード" />
  <TextHeightCutter :height="isMobile() ? 100 : 112.5" wrapper-class="content"
    :disableMoreButton="creditCards.length > 10">
    <ul class="plain-list-style two-column-list">
      <li v-for="(el10, index10) in creditCards" :key="`bath-type-${index10}`">
        {{ el10.equipServNm2 }}
      </li>
    </ul>
  </TextHeightCutter>
  <hr class="std-line-breaker" />
</div>

<!-- その他サービス -->
<div class="service-section box" v-if="otherServices.length > 0">
  <DashTitle text="その他サービス" />
  <TextHeightCutter :height="isMobile() ? 100 : 112.5" wrapper-class="content"
    :disableMoreButton="otherServices.length > 10">
    <ul class="plain-list-style two-column-list">
      <li v-for="(el11, index11) in otherServices" :key="`bath-type-${index11}`">
        {{ el11.equipServNm2 }}
      </li>
    </ul>
  </TextHeightCutter>
  <hr class="std-line-breaker" />
</div>

<div class="service-section box" v-if="surroundingFacilities.length > 0">
  <DashTitle text="周辺施設" />
  <TextHeightCutter :height="isMobile() ? 100 : 112.5" wrapper-class="content"
    :disableMoreButton="surroundingFacilities.length > 10">
    <ul class="plain-list-style two-column-list">
      <li v-for="(el12, index12) in surroundingFacilities" :key="`bath-type-${index12}`">
        {{ el12.equipServNm2 }}
      </li>
    </ul>
  </TextHeightCutter>
  <hr class="std-line-breaker" />
</div>

  </div>
</template>

<script>
import _ from 'lodash'
import { SectionContentTitle, DashTitle, TextHeightCutter } from '@/components/compound'

export default {
  components: {
    SectionContentTitle,
    DashTitle,
    TextHeightCutter
  },
  props: {
    equipmentServiceData: {
      type: Array,
      default: () => []
    }
  },
  watch: {
    equipmentServiceData() {
      if (this.equipmentServiceData) this.initServiceData(this.equipmentServiceData)
    }
  },
  data() {
    return {
      latitude: null,
      longitude: null,
      dataService: {},
      objSubHeader: {},
      menuNm: null,
      breadcrumb_data: [
        'トップ',
        '旅・宿泊',
        '国内宿泊',
        '宿泊施設名宿泊施設名宿泊施設名'
      ],
      open: false,
      bathtubType: null,
      bathtubQuality: null,
      bathtubEfficiency: null,
      breakfast: null,
      dinner: null,
      equipmentProduct: null,
      facilitiesHall: null,
      barrierFree: null,
      creditCard: null,
      otherService: [],
      peripherals: null,
      infectionControl: []
    }
  },
  computed: {
    breakfastItems() {
      if ( this.breakfast && this.breakfast.equipServDetail2.length > 0 ) {
        return this.breakfast.equipServDetail2.filter(item => item.equipServNm2 && this.isShow(item.equipServValue2))
      }
      return [];
    },
    dinnerItems() {
      if ( this.dinner && this.dinner.equipServDetail2.length > 0 ) {
        return this.dinner.equipServDetail2.filter(item => item.equipServNm2 && this.isShow(item.equipServValue2))
      }
      return [];
    },
    breakfastAndDinnerItems() {
      return this.breakfastItems.concat(this.dinnerItems);
    },
    buildingFacilities() {
      if ( this.facilitiesHall && this.facilitiesHall.equipServDetail2.length > 0 ) {
       return this.facilitiesHall.equipServDetail2.filter((el8) => el8 && this.isShow(el8.equipServValue2))
      }
      return [];
    },
    roomFacilityEquipments() {
      if ( this.equipmentProduct && this.equipmentProduct.equipServDetail2.length > 0 ) {
       return this.equipmentProduct.equipServDetail2.filter((el7) => el7 && this.isShow(el7.equipServValue2)) 
      }
      return [];
    },
    impedimentRemoval() {
      if ( this.barrierFree && this.barrierFree.equipServDetail2.length > 0 ) {
       return this.barrierFree.equipServDetail2.filter((el9) => el9 && this.isShow(el9.equipServValue2))
      }
      return [];
    },
    creditCards() {
      if ( this.creditCard && this.creditCard.equipServDetail2.length > 0 ) {
        return this.creditCard.equipServDetail2.filter((el10) => el10 && this.isShow(el10.equipServValue2))
      }
      return [];
    },
    otherServices() {
      if ( this.otherService.length > 0 ) {
        return this.otherService.filter((el11) => el11 && this.isShow(el11.equipServValue2))
      }
      return [];
    },
    surroundingFacilities() {
      if ( this.peripherals && this.peripherals.equipServDetail2 ) {
        return this.peripherals.equipServDetail2.filter((el12) => el12 && this.isShow(el12.equipServValue2))
      }
      return [];
    },
    hasServices() {
      const hasBathtub = this.bathtubType || this.bathtubQuality || this.bathtubType
      const hasBreakfastOrDinner = this.breakfast || this.dinner
      const hasEquipmentProduct = this.equipmentProduct?.equipServDetail2
      const hasFacilitiesHall = this.facilitiesHall?.equipServDetail2
      const hasBarrierFree = this.barrierFree?.equipServDetail2
      const hasCreditCard = this.creditCard?.equipServDetail2
      const hasOtherService = this.otherService.length > 0
      const hasPeripherals = this.peripherals?.equipServDetail2
      const hasInfectionControl = this.infectionControl.length > 0
      return (
        hasBathtub ||
        hasBreakfastOrDinner ||
        hasEquipmentProduct ||
        hasFacilitiesHall ||
        hasBarrierFree ||
        hasCreditCard ||
        hasOtherService ||
        hasPeripherals ||
        hasInfectionControl
      )
    }
  },
  methods: {
    initServiceData(data) {
      data.forEach((elementParent) => {
        elementParent.equipServDetail1.forEach((element) => {
          if (element.equipServCd1 === 'A100101') {
            const equipServCd2Set = new Set(
              element.equipServDetail2.map((item) => {
                return item.equipServCd2
              })
            )
            const equipServCd2SetConstant = new Set([
              'A10010101',
              'A10010102',
              'A10010103',
              'A10010104',
              'A10010105',
              'A10010106',
              'A10010107',
              'A10010108',
              'A10010109',
              'A10010110'
            ])

            equipServCd2SetConstant.forEach((element2) => {
              if (!equipServCd2Set.has(element2)) {
                element.equipServDetail2.push({
                  equipServCd2: element2,
                  equipServValues2: null,
                  equipServValue2: '×',
                  equipServNm2: ''
                })
              }
            })

            element.equipServDetail2.sort((a, b) => {
              if (a.equipServCd2 < b.equipServCd2) {
                return -1
              }
              if (a.equipServCd2 > b.equipServCd2) {
                return 1
              }
              return 0
            })
            this.bathtubType = element
          }
          if (element.equipServCd1 === 'A100102') {
            this.bathtubQuality = element
          }
          if (element.equipServCd1 === 'A100103') {
            this.bathtubEfficiency = element
          }
          if (element.equipServCd1 === 'A100201' && element.equipServNm1 === '朝食') {
            this.breakfast = element
          }
          if (element.equipServCd1 === 'A100202') {
            this.dinner = element
          }
          if (element.equipServCd1 === 'A100301') {
            this.equipmentProduct = element
          }
          if (element.equipServCd1 === 'A100401') {
            this.facilitiesHall = element
          }
          if (element.equipServCd1 === 'A100404') {
            this.barrierFree = element
          }
          if (element.equipServCd1 === 'A100601') {
            this.creditCard = element
          }
          if (element.equipServCd1 === 'A100402' || element.equipServCd1 === 'A100403') {
            this.otherService = this.otherService.concat(element.equipServDetail2)
          }
          if (element.equipServCd1 === 'A100501') {
            this.peripherals = element
          }

          const infectionControlCd1SetConstant = new Set([
            '20000000000',
            '20000000001',
            '20000000002',
            '20000000003',
            '20000000004',
            '20000000005',
            '20000000006',
            '20000000007',
            '20000000008',
            '20000000009'
          ])
          if (infectionControlCd1SetConstant.has(element.equipServCd1)) {
            this.infectionControl = this.infectionControl.concat(element.equipServDetail2)
            this.infectionControl = this.infectionControl.filter(
              (item) => this.isShow(item.equipServValue2)
            )
          }
        })
      })
    },
    getEquipServValue(item) {
      return item.equipServValue2 ? item.equipServValue2 : ''
    },
    /**
     * 設備を表示するかの判定
     * @param val {string} 設備サービス値
     * @return {boolean} 表示ならtrue
     */
    isShow(val) {
      // TODO MNからは○〇の2パターンが返ってきている可能性があるため、
      // MNの設計レベルでおかしく、本来はtrue/falseであるべき
      // 暫定対応として、「まる」で変換できる３種類の丸と比較しておく
      // https://typetalk.com/topics/322409/posts/96353151
      return val && (val == '〇' || val == '○' || val == '◯');
    }
  }
}
</script>

<style lang="scss" scoped>
@import './styles.scss';
</style>
